var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingEnergyValveGrouplevel = function SvgDCoolingEnergyValveGrouplevel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.05,
    y: 320.01,
    width: 28,
    height: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.05,
    y: 315.01,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "88.55 317.87 101.04 325 88.56 332.14 88.55 317.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.05,318.73l10.98,6.26-10.97,6.29v-12.55M88.05,317.01v16s14-8.01,14-8.01l-14-7.98h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "103.06 325 115.54 317.87 115.55 332.14 103.06 325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.04,318.73v12.55s-10.98-6.29-10.98-6.29l10.98-6.26M116.04,317.01l-13.99,7.98,14,8.01v-16h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 102.05,
    cy: 304.02,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.05,294.02c5.51,0,10,4.48,10,10s-4.49,10-10,10-10-4.48-10-10,4.49-10,10-10M102.05,293.02c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.97,300.67v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.05,
    y: 314.99,
    width: 2,
    height: 5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 102.05,
    cy: 324.99,
    r: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.05,320.99c2.21,0,4,1.79,4,4s-1.79,4-4,4-4-1.79-4-4,1.79-4,4-4M102.05,319.99c-2.76,0-5,2.24-5,5s2.24,5,5,5,5-2.24,5-5-2.24-5-5-5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 316.99,
    width: 4,
    height: 16,
    transform: "translate(172.1 649.98) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.05,317.99v14h-2v-14h2M88.05,316.99h-4v16h4v-16h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.05,
    y: 316.99,
    width: 4,
    height: 16,
    transform: "translate(124.1 649.98) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.05,317.99v14h-2v-14h2M64.05,316.99h-4v16h4v-16h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.05,
    y: 319.99,
    width: 22,
    height: 10,
    transform: "translate(148.1 649.98) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.05,320.99v8h-20v-8h20M85.05,319.99h-22v10h22v-10h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.91,323.78c-3.65,0-7.44-1.09-10.15-2.92l.56-.83c2.55,1.72,6.13,2.75,9.59,2.75s7.11-1.05,9.62-2.75l.56.83c-2.71,1.83-6.51,2.92-10.18,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.53,329.96c-2.51-1.7-6.2-2.75-9.62-2.75s-7.04,1.03-9.59,2.75l-.56-.83c2.71-1.83,6.5-2.92,10.15-2.92s7.47,1.09,10.18,2.92l-.56.83Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.05,
    y: 293,
    width: 22,
    height: 21.99,
    transform: "translate(148.1 607.99) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.05,294v19.99h-20v-19.99h20M85.05,293h-22v21.99h22v-21.99h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.12,305.37l1.45-4.45h1.09l-2.05,5.69h-.96l-2.04-5.69h1.08l1.43,4.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.05 304.5 85.05 304.5 85.04 303.51 91.05 303.52 91.05 304.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "57.58 300.45 63 299.01 57.58 297.55 57.58 298.5 53 298.49 53 299.49 57.58 299.5 57.58 300.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.58 308.5 53 308.49 53 309.49 57.58 309.5 57.58 310.45 63 309.01 57.58 307.55 57.58 308.5"
  }))))));
};
export default SvgDCoolingEnergyValveGrouplevel;